// @flow
export const filterId: 'sellType' = 'sellType';
